import { createGeneralPageEventsAndComponents } from "../technical/page-general";
import { getParentWithClassName, expressQuerySelector, expressQuerySelectorAll } from "../../common/html";
import { createCollapsable } from "../molecules/collapsable";
import { getHtmlRequest } from "../../utils/fetch";
import { showLoadingDialog } from "../popups/loading-dialog";

window.addEventListener('DOMContentLoaded', () => {
	const parentClass = 'technical-pricelist';
	const pricelistParentEl = expressQuerySelector(document, '.' + parentClass);

	const addCollapsibleEventHandlers = (collapsableEls) => {
		if (collapsableEls && collapsableEls.length > 0)
			collapsableEls.forEach(el => createCollapsable(el));
	};

	const addShowMoreEventHandlers = (showMoreButtonEls: HTMLElement[]) => {
		showMoreButtonEls.forEach(showMoreButtonEl => {
			showMoreButtonEl.addEventListener("click", () => {
				event.preventDefault();

				showMoreButtonEl.classList.toggle("a-button--open");

				const showmoreTableParent = getParentWithClassName(showMoreButtonEl, 'technical-pricelist-option-parent');
				const optionSubTable = expressQuerySelector(showmoreTableParent, '.technical-pricelist-option');
				optionSubTable.classList.toggle("u-hide");
			});
		});
	};

	const init = () => {
		const collapsableEls = expressQuerySelectorAll<HTMLElement>(pricelistParentEl, '.technical-collapsable');
		addCollapsibleEventHandlers(collapsableEls);

		const collapsableCategorygroupEls = expressQuerySelectorAll<HTMLElement>(pricelistParentEl, '.technical-pricelist-categorygroup .technical-collapsable-title');
		collapsableCategorygroupEls.forEach(collapsableCategorygroupEl => {
			const clickHandler = () => {
				const parentEl = getParentWithClassName<HTMLElement>(collapsableCategorygroupEl, 'technical-pricelist-categorygroup');
				const contentKey = parentEl.dataset.categorygroupcontentkey;

				showLoadingDialog(getHtmlRequest('/apicore/pricelistapi/getcategorygroupcollapsablecontent?contentKey=' + contentKey)
					.then((response: string) => {
						const collapseContentEl = expressQuerySelector<HTMLElement>(parentEl, '.technical-collapse-content');
						collapseContentEl.innerHTML = response;
						collapsableCategorygroupEl.removeEventListener('click', clickHandler);

						const collapsableEls = expressQuerySelectorAll<HTMLElement>(collapseContentEl, '.technical-collapsable');
						addCollapsibleEventHandlers(collapsableEls);

						const showMoreButtonEls = expressQuerySelectorAll<HTMLElement>(collapseContentEl, '.technical-showmore-button');
						addShowMoreEventHandlers(showMoreButtonEls);
					}), 0);
			};

			collapsableCategorygroupEl.addEventListener('click', clickHandler);
		});
	};

	init();
	createGeneralPageEventsAndComponents();
});
